/* eslint-disable */
export default {
  download: 'ダウンロード',
  play: '再生',
  pause: '一時停止',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
